import { S as e, r as t } from "./useCollections-Vgy92T1D.js";
import { Box as n, InputText as r, Text as i } from "@dixa/lib-shared-habla";
import { jsx as a, jsxs as o } from "react/jsx-runtime";
import { useCallback as s, useContext as c } from "react";
import l from "classnames";
//#region ../management-common/src/utils/translations.ts
function u(e, n = t.En) {
	return e.find((e) => e.languageId === n)?.title || `${e[0].title}`;
}
//#endregion
//#region ../management-common/src/utils/categoryDropdownItems.ts
var d = ({ currentCategoryId: e, disabledCategoryIds: t }) => (n, r) => {
	let i = r.id === e || t.includes(r.id), a = u(r.titles);
	return n.listItems.push({
		disabled: i,
		id: r.id,
		type: r.__typename,
		name: a,
		nestLevel: n.nestLevel
	}), !i && r.categories?.reduce(d({
		disabledCategoryIds: t,
		currentCategoryId: e
	}), {
		listItems: n.listItems,
		nestLevel: n.nestLevel + 1
	}), n;
};
function f({ categories: e, currentCategoryId: t, disabledCategoryIds: n, withCollectionOption: r, collectionId: i }) {
	if (!i) throw Error("collectionId is required");
	let a = e.reduce(d({
		currentCategoryId: t,
		disabledCategoryIds: n
	}), {
		listItems: r ? [{
			name: "None",
			type: "Collection",
			id: i,
			disabled: !1,
			nestLevel: -1
		}] : [],
		nestLevel: 0
	}).listItems;
	return {
		listItems: a.map((e) => ({
			id: e.id,
			name: m(e.name, e.nestLevel)
		})),
		allDisabledCategoryIds: a.filter((e) => e.disabled).map((e) => e.id)
	};
}
var p = "\xA0\xA0\xA0\xA0";
function m(e, t) {
	return `${Array.from({ length: t }).map(() => p).join("")}${e}`;
}
var h = {
	modalBody: "_modalBody_1ujd2_54",
	articleContainer: "_articleContainer_1ujd2_58",
	legacyArticleBackground: "_legacyArticleBackground_1ujd2_65",
	articleContent: "_articleContent_1ujd2_70",
	improveArticle: "_improveArticle_1ujd2_96",
	input: "_input_1ujd2_100"
};
//#endregion
//#region src/components/Modals/components/articleContentPreview.tsx
function g({ title: e, articleContent: t, className: r }) {
	return /* @__PURE__ */ o(n, {
		className: l(h.articleContainer, r),
		children: [e && /* @__PURE__ */ a(i.Heading, {
			variant: "heading-1",
			children: e
		}), /* @__PURE__ */ a(n, {
			className: h.articleContent,
			dangerouslySetInnerHTML: { __html: t }
		})]
	});
}
//#endregion
//#region src/components/Modals/components/improveArticleInput.tsx
function _({ value: e, onChange: t, onSubmit: s, isGenerating: c, isSaving: u, className: d }) {
	return /* @__PURE__ */ o(n, {
		className: l(h.improveArticle, d),
		children: [/* @__PURE__ */ a(i.Heading, {
			variant: "heading-2",
			children: "Improve article"
		}), /* @__PURE__ */ a(r, {
			className: h.input,
			onChange: (e) => t(e.target.value),
			onKeyDown: (n) => {
				if (n.key === "Enter") return s(e);
				if (n.key === "Escape") return t("");
			},
			value: e,
			disabled: c,
			placeholder: "Ask AI to edit or generate...",
			suffix: {
				type: "button",
				button: {
					icon: "enter",
					onClick: () => s(e),
					isLoading: c,
					disabled: u
				}
			}
		})]
	});
}
//#endregion
//#region ../utils/src/hooks/useNotification.ts
function v() {
	let t = c(e);
	return {
		errorNotify: s(({ title: e = "Something went wrong", text: n, ...r }) => {
			t({
				icon: "exclamation-circle-filled",
				time: 2e3,
				status: "danger",
				reason: null,
				waitingTime: null,
				startTime: null,
				leftAction: null,
				...r,
				title: e,
				text: n
			});
		}, [t]),
		successNotify: s(({ title: e, text: n, ...r }) => {
			t({
				icon: "check-circle-filled",
				time: 3e3,
				status: "success",
				reason: null,
				waitingTime: null,
				startTime: null,
				leftAction: null,
				...r,
				title: e,
				text: n
			});
		}, [t]),
		notify: t
	};
}
//#endregion
export { f as a, h as i, _ as n, g as r, v as t };

//# sourceMappingURL=useNotification-BENN0i41.js.map